/**
 * Variable to store user token.
 * @type {String}
 */
let token

/**
 * Set user data.
 * @param {Object} d - User data to be set.
 */
export const setToken = (t) => {
  token = t
  localStorage.setItem('token', token)
}

/**
 * Check if user is logged in.
 * @returns {boolean} True if user is logged in, otherwise false.
 */
export const isUserLoggedIn = () => {
  return token || localStorage.getItem('token')
}

/**
 * Logs out the user by clearing user data and removing token from localStorage.
 */
export const userLogOut = () => {
  token = null
  localStorage.removeItem('token')
}
